export type Palette = {
  series: Array<string>;
  muted: string;
  shade: string;
  surface: string;
  hairline: string;
  hairlineStrong: string;
  ink: string;
  ink2: string;
  ink3: string;
  pos: string;
  neg: string;
  sans: string;
};

export function paletteOf(root: Element): Palette {
  const style = getComputedStyle(root);
  const read = (name: string) => style.getPropertyValue(name).trim();
  return {
    series: [1, 2, 3, 4, 5, 6, 7, 8].map((index) => read(`--chart-${index}`)),
    muted: read('--muted-mark'),
    shade: read('--shade'),
    surface: read('--surface'),
    hairline: read('--hairline'),
    hairlineStrong: read('--hairline-strong'),
    ink: read('--ink'),
    ink2: read('--ink-2'),
    ink3: read('--ink-3'),
    pos: read('--pos'),
    neg: read('--neg'),
    sans: read('--sans'),
  };
}
